import { useMemo } from "react";
import { Link } from "react-router-dom";
import { CheckIcon, Edit, Pencil, Trash2 } from "lucide-react";
// @ts-ignore
import moment from "moment-jalaali";
import { CellContext } from "@tanstack/react-table";

interface ColumnsProps {
  onClickDelete: (data: any) => void;
  handleUpdateDataClick: (data: any) => void;
}

const FarmerColumn = ({
  onClickDelete,
  handleUpdateDataClick,
}: ColumnsProps) => {
  return [
    {
      header: "نام و نام خانوادگی",
      accessorKey: "full_name",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
    {
      header: "کد ملی",
      accessorKey: "national_id",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
    {
      header: "نام پدر",
      accessorKey: "father_name",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
    {
      header: "شماره همراه ",
      accessorKey: "phone_number",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
    {
      header: "شماره شبا اول",
      accessorKey: "sheba_number_1",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
    {
      header: "شماره شبا دوم",
      accessorKey: "sheba_number_2",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
    {
      header: "شماره  کارت",
      accessorKey: "card_number",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },

    {
      header: "آدرس",
      accessorKey: "address",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },

    {
      header: "عملیات",
      enableColumnFilter: false,
      enableSorting: true,
      cell: (cell: any) => (
        <div className="flex gap-3">
          <Link
            to="#!"
            data-modal-target="addEmployeeModal"
            className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md edit-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
            onClick={() => {
              const data = cell.row.original;
              handleUpdateDataClick(data);
              // Call the onClick function here
            }}
          >
            <span className="rounded p-1 w-20 ml-3 bg-green-600 text-white">
                ویرایش
              </span>
          </Link>
          <Link
            to="#!"
            className="flex items-center mr-4 justify-center size-8 transition-all duration-200 ease-linear rounded-md remove-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
            onClick={() => {
              const data = cell.row.original;
              onClickDelete(data);
            }}
          >
           <span className="rounded p-1 px-1 w-20 ml-3 bg-red-600 text-white">
                حذف
              </span>
          </Link>
        </div>
      ),
    },

    {
      header: "تاریخ ایجاد",
      accessorKey: "created_at",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <Link
          to="#"
          className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
        >
          {cell.getValue()}
        </Link>
      ),
    },
  ];
};

export default FarmerColumn;
